"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KENALLV1 = void 0;
var axios_1 = __importDefault(require("axios"));
var superstruct_1 = require("superstruct");
var validators_1 = require("./validators");
var DEFAULT_APIBASE_V1 = 'https://api.kenall.jp/v1';
function normalizePostalCode(postalCode) {
    var match = postalCode.match(/^(\d{3})-(\d{4})$/);
    if (match) {
        return match[1] + match[2];
    }
    return postalCode;
}
var KENALLV1 = /** @class */ (function () {
    /**
     * The constructor.
     *
     * @param apikey The key string that you want to call the API with. The key is
     *               shown in the dashboard you will be navigated to right after
     *               signing in to the service.
     * @param config Specfies the configuration given by {@link Config}.
     */
    function KENALLV1(apikey, config) {
        if (config === void 0) { config = {}; }
        this.apikey = apikey;
        this.apibase = config.apibase || DEFAULT_APIBASE_V1;
        this.timeout = config.timeout || 1000;
        this.axios = axios_1.default.create({
            baseURL: this.apibase,
            timeout: this.timeout,
            headers: { Authorization: "Token " + this.apikey },
        });
    }
    KENALLV1.prototype.request = function (endpoint, params, apiVersion) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get(endpoint, {
                            params: params,
                            headers: __assign({}, (apiVersion ? { 'KenAll-API-Version': apiVersion } : {})),
                        })];
                    case 1:
                        r = _a.sent();
                        return [2 /*return*/, r.data];
                }
            });
        });
    };
    /**
     * Invokes "getAddress" API (endpoint: `/postalcode/{postalcode}`).
     *
     * @param postalCode The postal code to query with.
     * @param version The version of the database that the query has to be
     *                performed against. Will default to the latest available
     *                version if not specified.
     * @param apiVersion The API version. The return type is determined based
     *                   on this argument, and thus it cannot be a variable.
     * @returns An {@link AddressResolverResponse}.
     */
    KENALLV1.prototype.getAddress = function (postalCode, version, apiVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/postalcode/" + normalizePostalCode(postalCode), version != undefined ? { version: version } : {}, apiVersion)];
                    case 1:
                        resp = _a.sent();
                        try {
                            return [2 /*return*/, (0, validators_1.getValidators)(apiVersion).validateAddressResolverResponse(resp)];
                        }
                        catch (e) {
                            if (e instanceof superstruct_1.StructError) {
                                throw new Error("invalid response payload: " + e.path + " must be " + e.type);
                            }
                            else {
                                throw e;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Invokes "getCities" API (endpoint: `/cities/{prefectureCode}`).
     *
     * @param prefectureCode The prefecture code to query with.
     * @param version The version of the database that the query has to be
     *                performed against. Will default to the latest available
     *                version if not specified.
     * @param apiVersion The API version. The return type is determined based
     *                   on this argument, and thus it cannot be a variable.
     * @returns A {@link CityResolverResponse}.
     */
    KENALLV1.prototype.getCities = function (prefectureCode, version, apiVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/cities/" + prefectureCode, version != undefined ? { version: version } : {}, apiVersion)];
                    case 1:
                        resp = _a.sent();
                        try {
                            return [2 /*return*/, (0, validators_1.getValidators)(apiVersion).validateCityResolverResponse(resp)];
                        }
                        catch (e) {
                            if (e instanceof superstruct_1.StructError) {
                                throw new Error("invalid response payload: " + e.path + " must be " + e.type);
                            }
                            else {
                                throw e;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Invokes "searchAddresses" API (endpoint: `/postalcode/?...`).
     *
     * @param options The query.
     * @param apiVersion The API version. The return type is determined based
     *                   on this argument, and thus it cannot be a variable.
     * @returns An {@link AddressSearcherResponse}.
     */
    KENALLV1.prototype.searchAddresses = function (options, apiVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var params, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {};
                        if (options.q !== undefined) {
                            params['q'] = options.q;
                        }
                        if (options.t !== undefined) {
                            params['t'] = options.t;
                        }
                        if (options.offset !== undefined) {
                            params['offset'] = String(options.offset | 0);
                        }
                        if (options.limit !== undefined) {
                            params['limit'] = String(options.limit | 0);
                        }
                        if (options.version !== undefined) {
                            params['version'] = options.version;
                        }
                        if (options.facet !== undefined) {
                            params['facet'] = options.facet;
                        }
                        return [4 /*yield*/, this.request('/postalcode/', params, apiVersion)];
                    case 1:
                        resp = _a.sent();
                        try {
                            return [2 /*return*/, (0, validators_1.getValidators)(apiVersion).validateAddressSearcherResponse(resp)];
                        }
                        catch (e) {
                            if (e instanceof superstruct_1.StructError) {
                                throw new Error("invalid response payload: " + e.path + " must be " + e.type);
                            }
                            else {
                                throw e;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Invokes "getNTACorporateInfo" API (endpoint: `/houjinbangou/{corporateNumber}`).
     *
     * @param corporateNumber The corporate number to query with.
     * @param apiVersion The API version. The return type is determined based
     *                   on this argument, and thus it cannot be a variable.
     * @returns An {@link NTACorporateInfoResolverResponse}.
     */
    KENALLV1.prototype.getNTACorporateInfo = function (corporateNumber, apiVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/houjinbangou/" + corporateNumber, {}, apiVersion)];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, (0, validators_1.getValidators)(apiVersion).validateNTACorporateInfoResolverResponse(resp)];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1 instanceof superstruct_1.StructError) {
                            throw new Error("invalid response payload: " + e_1.path + " must be " + e_1.type);
                        }
                        else {
                            throw e_1;
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Invokes "searchNTACorporateInfo" API (endpoint: `/houjinbangou?...`).
     *
     * @param options The query.
     * @param apiVersion The API version. The return type is determined based
     *                   on this argument, and thus it cannot be a variable.
     * @returns An {@link NTACorporateInfoSearcherResponse}.
     */
    KENALLV1.prototype.searchNTACorporateInfo = function (options, apiVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var params, resp, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {};
                        if (options.query !== undefined) {
                            params['q'] = options.query;
                        }
                        if (options.mode !== undefined) {
                            params['mode'] = options.mode;
                        }
                        if (options.offset !== undefined) {
                            params['offset'] = String(options.offset | 0);
                        }
                        if (options.limit !== undefined) {
                            params['limit'] = String(options.limit | 0);
                        }
                        if (options.facet_area !== undefined) {
                            params['facet_area'] = options.facet_area;
                        }
                        if (options.facet_kind !== undefined) {
                            params['facet_kind'] = options.facet_kind;
                        }
                        if (options.facet_process !== undefined) {
                            params['facet_process'] = options.facet_process;
                        }
                        if (options.facet_close_cause !== undefined) {
                            params['facet_close_cause'] = options.facet_close_cause;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request('/houjinbangou', params, apiVersion)];
                    case 2:
                        resp = _a.sent();
                        return [2 /*return*/, (0, validators_1.getValidators)(apiVersion).validateNTACorporateInfoSearcherResponse(resp)];
                    case 3:
                        e_2 = _a.sent();
                        if (e_2 instanceof superstruct_1.StructError) {
                            throw new Error("" + e_2
                            //  `invalid response payload: ${e.path} must be ${e.type}`
                            );
                        }
                        else {
                            throw e_2;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Invokes "getNTAQualifiedInvoiceIssuerInfo" API (endpoint: `/invoice/{issuerNumber}`).
     *
     * @param issuerNumber The qualified invoice issuer number to query with.
     * @param apiVersion The API version. The return type is determined based
     *                   on this argument, and thus it cannot be a variable.
     * @returns An {@link NTAQualifiedInvoiceIssuerResolverResponse}.
     */
    KENALLV1.prototype.getNTAQualifiedInvoiceIssuerInfo = function (issuerNumber, apiVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/invoice/" + issuerNumber, {}, apiVersion)];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, (0, validators_1.getValidators)(apiVersion).validateNTAQualifiedInvoiceIssuerInfoResolverResponse(resp)];
                    case 2:
                        e_3 = _a.sent();
                        if (e_3 instanceof superstruct_1.StructError) {
                            throw new Error("invalid response payload: " + e_3.path + " must be " + e_3.type);
                        }
                        else {
                            throw e_3;
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return KENALLV1;
}());
exports.KENALLV1 = KENALLV1;
